export type RowType = {
  name: string
  code: string
  order: number
  group: string
}

export const ROW_TYPE_ARRIVAL_QUANTITY: RowType = {
  name: '入荷',
  code: 'arrivalQuantity',
  order: 1,
  group: '入荷',
}

export const ROW_TYPE_ORDER_QUANTITY_REC: RowType = {
  name: '発注実績',
  code: 'orderQuantityRec',
  order: 2,
  group: '入荷',
}

export const ROW_TYPE_ORDER_QUANTITY_RECOMMEND: RowType = {
  name: '推奨数',
  code: 'orderQuantityRecommend',
  order: 3,
  group: '入荷',
}

export const ROW_TYPE_ARRIVAL_QUANTITY_PLAN: RowType = {      
  name: '入荷数調整',
  code: 'arrivalQuantityPlan',
  order: 4,
  group: '入荷',
}

export const ROW_TYPE_ORDER_QUANTITY: RowType = {      
  name: '確定数',
  code: 'orderQuantity',
  order: 5,
  group: '入荷',
}

export const ROW_TYPE_SHIP_QUANTITY: RowType = {
  name: '出荷',
  code: 'shipQuantity',
  order: 1,
  group: '出荷',
}

export const ROW_TYPE_SHIP_QUANTITY_EXPECTED: RowType = {
  name: '出荷予測',
  code: 'shipQuantityExpected',
  order: 2,
  group: '出荷',
}

export const ROW_TYPE_SALESORDER_QUANTITY: RowType = {
  name: '受注実績',
  code: 'salesorderQuantity',
  order: 3,
  group: '出荷',
}

export const ROW_TYPE_SALESORDER_PLAN: RowType = {
  name: '出荷数調整',
  code: 'shipQuantityPlan',
  order: 4,
  group: '出荷',
}

export const ROW_TYPE_STOCK_DAYS: RowType = {
  name: '在庫日数',
  code: 'stockDays',
  order: 1,
  group: '在庫日数',
}

export const ROW_TYPE_AVG_SHIP_QUANTITY_STOCK_BASE: RowType = {
  name: '翌日以降出荷数平均',
  code: 'avgShipQuantityStockBase',
  order: 2,
  group: '在庫日数',
}

export const ROW_TYPE_STOCK_QUANTITY: RowType = {
  name: '在庫数',
  code: 'stock_quantity',
  order: 1,
  group: '在庫数',
}

export const ROW_TYPE_STOCK_QUANTITY_REC: RowType = {
  name: '在庫数実績',
  code: 'stockQuantityRec',
  order: 2,
  group: '在庫数',
}

export const ROW_TYPE_CALC_SAFETY: RowType = {
  name: '安全在庫数',
  code: 'calcSafety',
  order: 3,
  group: '在庫数',
}

export const ROW_TYPE_STOCK_QUANTITY_SHIP_STOP: RowType = {
  name: '在庫調整数',
  code: 'stockQuantityShipStop',
  order: 4,
  group: '在庫数',
}

export const ROW_TYPE_REMARKS: RowType = {
  name: '備考',
  code: 'remarks',
  order: 1,
  group: '備考',
}

export type StockCell = {
  recDate: Date
  orderDate: Date | null
  value: any | null
  shipQuantityRaw?: number | null
  oldValue: number | null
  enableUpdate: boolean
  enableData: boolean
  isUpdate: boolean
  isCurrentUpdate: boolean
  recType: string | null
  fixFlg?: boolean
  isCheckbox?: boolean
  updateDatetime?: Date | null
  stockPlanUpdateDatetime?: Date | null
  isUpdatedArrival?: boolean
  isUpdatedShip?: boolean
  orderQuantityRecommend?: number | null
  orderQuantityRec?: number | null
  shipQuantityScheduled?: number | null
  remarks?: string | null
  olditemShipStopFlg?: boolean
  shipExclusionFlg?: boolean
  resetToRecommend?: boolean
  isOrderConfirmed?: boolean
  isUpdatedArrivalTmp?: boolean
  isOrderDay?: boolean
  isArrivalDay?: boolean
  isTodayOrderDay?: boolean
  stockDaysSetting?: number | null
  minStockQuantity?: number | null
  shipdaysNextArrival?: number | null
  isAlertMaster?: boolean
  isMinShipDateAlert?: boolean
  isEndSaleAlert?: boolean
  isInactive?: boolean
  isExpectedRankAlert?: boolean
}

export type StockCellWithPk = StockCell & {
  companyId: number
  centerId: number
  itemCode: string
  rowType: RowType
}

export type StockRow = {
  companyId: number
  centerId: number
  centerName?: string | null
  orgSupplierId?: string | null
  supplierName?: string | null
  orgItemCode: string
  itemCode: string | null
  itemName?: string | null
  janCase?: string | null
  expectedRank: number | null
  predictionMapeMedian?: number | null
  orderUnitTypeName?: string | null
  caseLot?: number | null
  minOrderQuantity?: number | null
  rowType: RowType | null
  stockDaysSetting: number | null
  safetyStockSetting: number | null
  minStockQuantity: number | null
  startDate: Date | null
  stopShip: boolean | null
  stopArrival: boolean | null
  renewalFlg: boolean | null
  renewalNumber: number | null
  weight?: number | null
  maxPalletQuantity?: number | null
  optimizeType: string | null
  isTotal: boolean
  isExpectedRankAlert?: boolean | null
  orderQuantityRecommend?: number | null
  shipQuantityScheduled?: number | null
  groupKey?: string
  [key: `col${number}`]: StockCell | null
}

